/**
 * Turn a product's position on the rendered page into its position in the whole result list.
 *
 * Both values are 1-based and count products only — the caller skips teasers and blockers while
 * walking the grid — so a teaser in the middle of the grid does not shift the numbering of the
 * products after it.
 *
 * `firstItemIndex` is the number of products on the pages before the first one the grid renders,
 * which the caller derives from the pagination and the page size (`ArticleOverviewContent`). Kept
 * as a plain addition here so the load-more group, whose grid holds several pages at once, needs no
 * special case: its running count already spans the loaded pages and the offset is the first
 * loaded page's.
 */
export function buildPositionInList(
    positionOnPage: number | undefined,
    firstItemIndex: number | undefined,
): number | undefined {
    if (positionOnPage === undefined || positionOnPage === null) {
        return undefined;
    }
    return (firstItemIndex ?? 0) + positionOnPage;
}
